import { DIG_SIGN_COM_1, VIDA } from 'common/constants';
import {
  checkValidatePhotoStatus,
  setValidatePhotoSignature
} from 'store/actions/disburse';
import { setApplicationStatusV3 } from 'store/actions/loanApply';

export const handleSuccessValidatePhotoSignatureV3 = (
  dispatch,
  auth,
  res,
  param,
  isFlowSuplesiActive
) => {
  const data = res?.data?.data?.[0];

  dispatch(setValidatePhotoSignature(res.data));

  const { statusAfterDocCreation, eSignVendor, vidaESignId } = data;

  const isVidaFlow =
    statusAfterDocCreation === DIG_SIGN_COM_1 || eSignVendor === VIDA;

  if (isVidaFlow) {
    const eSignId = vidaESignId?.split('|');
    dispatch(
      checkValidatePhotoStatus(auth, eSignId, param, isFlowSuplesiActive)
    );
    return;
  }

  dispatch(setApplicationStatusV3(statusAfterDocCreation));
};
